(function () {
  'use strict';

  function initMobileBottleClockRotation() {
    var mobile = window.matchMedia('(max-width: 1100px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var hero = document.getElementById('sf-hero');
    var bottle = document.getElementById('sf-hero-product');
    var labels = hero ? Array.prototype.slice.call(hero.querySelectorAll('[data-sf-clock-step]')) : [];
    var frameId = 0;
    var startTime = 0;
    var lastActive = -1;

    if (!hero || !bottle || !labels.length) return;

    function updateActiveLabel(angle) {
      var stepAngle = 360 / labels.length;
      var activeIndex = Math.round(angle / stepAngle) % labels.length;
      if (activeIndex === lastActive) return;
      lastActive = activeIndex;
      labels.forEach(function (label, index) {
        label.classList.toggle('is-active', index === activeIndex);
      });
    }

    function tick(now) {
      if (!mobile.matches || reduced.matches) {
        frameId = 0;
        bottle.style.removeProperty('transform');
        return;
      }
      if (!startTime) startTime = now;
      var elapsed = (now - startTime) % 60000;
      var angle = elapsed / 60000 * 360;
      bottle.style.setProperty('transform', 'rotate(' + angle.toFixed(3) + 'deg)', 'important');
      updateActiveLabel(angle);
      frameId = window.requestAnimationFrame(tick);
    }

    function sync() {
      if (mobile.matches && !reduced.matches) {
        if (!frameId) {
          startTime = 0;
          frameId = window.requestAnimationFrame(tick);
        }
      } else {
        if (frameId) window.cancelAnimationFrame(frameId);
        frameId = 0;
        bottle.style.removeProperty('transform');
      }
    }

    mobile.addEventListener('change', sync);
    reduced.addEventListener('change', sync);
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileBottleClockRotation);
  } else {
    initMobileBottleClockRotation();
  }
})();

